import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { Form, Text } from 'components/common/form';

import type { BlockSequencingStateProps } from './EditorBlockSequencing';

interface Props extends BlockSequencingStateProps {
  deleteIsDisabled?: boolean;
  index: number;
  isPreview: boolean;
  onChange?: (option: string, index: number) => void;
  onDelete?: (index: number) => void;
  option: { id: string; text: string };
}

const EditorBlockSequencingOption = ({
  deleteIsDisabled = false,
  index,
  isPreview,
  onChange,
  onDelete,
  option,
  ...stateProps
}: Props) => {
  const { messages, theme } = useReduxState();

  const { editorLanguageActive } = stateProps;

  const handleChange = (option) => {
    onChange(option, index);
  };

  const handleDelete = () => {
    onDelete(index);
  };

  return (
    <div className="sequencing-input">
      <Form>
        <div className="input">
          {isPreview ? (
            <div
              style={{
                backgroundColor: 'white',
                border: `1px solid ${theme.lightGreyDark}`,
                borderRadius: theme.inputBorderRadius,
                color: theme.textColorLight,
                padding: 10
              }}
            >
              {option?.text || ''}
            </div>
          ) : (
            <Text
              aria-label={messages.commonQuestion}
              field={'option'}
              index={index}
              initialValue={option?.text}
              inputStyle={{
                padding: '10px 80px 10px 10px'
              }}
              key={option?.id + editorLanguageActive}
              onChange={handleChange}
              placeholder={messages.commonAddOption}
              value={option?.text}
            />
          )}

          {!isPreview && (
            <div className="buttons">
              <Button
                aria-label={messages.commonDelete}
                data-tooltip={messages.commonDelete}
                category="lighter"
                disabled={deleteIsDisabled}
                icon="trash-alt"
                onClick={handleDelete}
                size="small"
                style={{ display: 'inline-block', margin: '3px 3px 5px 3px' }}
              />
            </div>
          )}
        </div>
      </Form>

      <style jsx>{`
        .input {
          position: relative;
        }
        .buttons {
          display: inline-block;
          position: absolute;
          right: 4px;
          top: 4px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockSequencingOption;
